/**
 * StepStatusBadge — Status-Indikator für einen Step in der StepList.
 * @since v2.514.0 (#1173)
 *
 * status: 'ok' | 'warning' | 'error' | 'untested'
 */
export default function StepStatusBadge({ status = 'untested', size = 'sm' }) {
  const styles = {
    ok:       { bg: 'bg-emerald-50',  fg: 'text-emerald-700',  dot: 'bg-emerald-500',  label: 'OK' },
    warning:  { bg: 'bg-amber-50',    fg: 'text-amber-700',    dot: 'bg-amber-500',    label: 'Warnung' },
    error:    { bg: 'bg-rose-50',     fg: 'text-rose-700',     dot: 'bg-rose-500',     label: 'Fehler' },
    untested: { bg: 'bg-gray-100',    fg: 'text-gray-600',     dot: 'bg-gray-400',     label: 'ungetestet' },
  };
  const s = styles[status] || styles.untested;
  const dotSize = size === 'sm' ? 'w-1.5 h-1.5' : 'w-2 h-2';
  return (
    <span className={`inline-flex items-center gap-1.5 px-1.5 py-0.5 rounded ${s.bg} ${s.fg} text-[10px] font-medium`}>
      <span className={`${dotSize} rounded-full ${s.dot}`} />
      {s.label}
    </span>
  );
}
